<template>
    <div class="wrapper" v-bind:class="this.align">
        <div class="scroll-downs">
            <div class="mousey">
                <div class="scroller"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    props: ['align']
}
</script>
<style scoped>

.wrapper {
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  width: 40px;
  height: 80px;
}

.wrapper.center{
    margin: auto;
    margin-top: 48px;
    margin-bottom: 48px;
}
.wrapper.center-nomargin{
    margin: auto;
}
.scroll-downs {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  
  width :34px;
  height: 25px;
}
.mousey {
  width: 1px;
  padding: 3px 8px;
  height: 25px;
  border: 2px solid #fff;
  border-radius: 25px;
  opacity: 0.75;
  box-sizing: content-box;
}
.scroller {
  width: 1px;
  height: 8px;
  border-radius: 25%;
  background-color: #fff;
  animation-name: scroll;
  animation-duration: 2.2s;
  animation-timing-function: cubic-bezier(.15,.41,.69,.94);
  animation-iteration-count: infinite;
}
@keyframes scroll {
  0% { opacity: 0; }
  10% { transform: translateY(1px); opacity: 1; }
  100% { transform: translateY(10px); opacity: 0;}
}

@media screen and (max-width: 836px) {
  .wrapper{
    display: none;
  }
}
</style>